module.exports = "data:image/svg+xml;base64,PHN2ZyBjbGFzcz0iaWNvbiIgdmlld0JveD0iMCAwIDEwMjQgMTAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB3aWR0aD0iNjQiIGhlaWdodD0iNjQiPjxkZWZzPjxzdHlsZS8+PC9kZWZzPjxwYXRoIGQ9Ik02NCA2NGgzODR2Mzg0SDY0VjY0em0wIDUxMmgzODR2Mzg0SDY0VjU3NnptNTEyIDBoMzg0djM4NEg1NzZWNTc2em0xOTItMTI4YzEwNi4wMzkgMCAxOTItODUuOTYxIDE5Mi0xOTJTODc0LjAzOSA2NCA3NjggNjRzLTE5MiA4NS45NjEtMTkyIDE5MiA4NS45NjEgMTkyIDE5MiAxOTJ6Ii8+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/component.svg
// module id = s2cW
// module chunks = 72